import { Calendar, Divider, Spin, Typography } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useContext, useRef } from 'react';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';
import { useCrossLinkToOfferingsInbox } from '../AddMassOffering/useCrossLinkToOfferingsInbox';
import MassOfferings from '../MassOfferings';
import VariousMassOfferingSelector, {
  OFFERING_TYPE_WITH_TIME,
} from '../VariousMassOfferingSelector/VariousMassOfferingSelector';
import { calendarLocale } from '../../utils/calendarLocale';
import MassOfferingMassRequestMinDateDescription from '../MassOfferingMassRequestMinDateDescription';

import styles from './MassList.module.scss';
import MassListCell from './MassListCell';
import { MassListContext } from './MassListContext';
import { getEndOfNextYear } from './utils';

// Konfiguracja tekstów per accountId dla intencji terminowych
const MASS_INTENTION_ACCOUNT_SPECIFIC_MESSAGES = {
  '1232003310810333184':
    'UWAGA! W kalendarzu wyświetlają się tylko godziny Mszy św., na które można zamówić intencje przez Internet. Chcąc zamówić intencję na Mszy św. o g. 18:00 (w niedziele i dni powszednie) lub o 10:30 i 12:00 (w niedziele), należy skontaktować się z kancelarią lub przyjść do zakrystii. Dziękujemy.',
  654463132773478400: 'Intencję Mszy św. o g. 18:00 można zamówić w zakrystii lub kancelarii.',
  '1516868980247126016': 'Intencję Mszy św. o g. 18:00 można zamówić w zakrystii lub kancelarii.',
};

const MassList = ({ inboxDictionary }) => {
  const isFetchingMasses = useSelector(selectors.isFetchingMasses);
  const massesByDay = useSelector(selectors.getMassesByDay);
  const accountId = useSelector(selectors.getAccountId);

  const massOfferingMassRequestMinDate = useSelector(selectors.getMassOfferingMassRequestFromDate);
  const shouldShowMinDateDescription =
    massOfferingMassRequestMinDate &&
    moment(massOfferingMassRequestMinDate).isSameOrAfter(moment().startOf('day').add(1, 'day'));

  const getCrossLinkUrl = useCrossLinkToOfferingsInbox(inboxDictionary);

  const { selectedDate, setSelectedDate } = useContext(MassListContext);

  const validRange = useRef([moment().startOf('day'), getEndOfNextYear()]);

  const accountSpecificMessage = accountId
    ? MASS_INTENTION_ACCOUNT_SPECIFIC_MESSAGES[accountId]
    : null;

  const onSelect = newDate => {
    setSelectedDate(newDate);
  };

  return (
    <React.Fragment>
      <h2>Intencje online</h2>

      {getCrossLinkUrl && inboxDictionary && (
        <>
          <VariousMassOfferingSelector
            fieldName="whatever"
            fieldValue={OFFERING_TYPE_WITH_TIME.value}
            inboxDictionary={inboxDictionary}
            onChange={newType => {
              if (newType !== OFFERING_TYPE_WITH_TIME.value) {
                // eslint-disable-next-line no-restricted-globals
                location.href = getCrossLinkUrl(newType);
              }
            }}
          />

          <Divider />
        </>
      )}

      <Typography.Title level={4}>Termin Mszy Świętej</Typography.Title>

      <p>
        Znajdź odpowiednią datę Mszy Świętej wybierając dzień, a następnie jedną z dostępnych
        godzin.
      </p>

      {accountSpecificMessage && <p>{accountSpecificMessage}</p>}

      {shouldShowMinDateDescription && (
        <p>
          <MassOfferingMassRequestMinDateDescription
            massOfferingMassRequestMinDate={massOfferingMassRequestMinDate}
          />
        </p>
      )}

      <div className={styles.self}>
        {isFetchingMasses ? (
          <Spin className={styles.spin} />
        ) : (
          <div>
            <Calendar
              defaultValue={selectedDate}
              value={selectedDate}
              locale={calendarLocale}
              validRange={validRange.current}
              dateCellRender={momentValue => (
                <MassListCell momentValue={momentValue} massesByDay={massesByDay} />
              )}
              onSelect={onSelect}
            />

            <MassOfferings selectedDate={selectedDate} />
          </div>
        )}
      </div>
      {getCrossLinkUrl && (
        <>
          <br />
          <hr />
          <br />
          <div>
            <b>Inne dostępne rodzaje intencji</b>
            <br />
            Jeśli interesujący Cię termin jest niedostępny lub chcesz zamówić inny rodzaj intencji
            <a href={getCrossLinkUrl()}>
              {' '}
              zgłoś intencję do odprawienia w najbliższym dostępnym terminie
            </a>
            .
          </div>
        </>
      )}
    </React.Fragment>
  );
};

MassList.propTypes = {
  inboxDictionary: PropTypes.array,
};

export default MassList;
